const $ = window.jQuery

// import LazyLoad from 'vanilla-lazyload'
// import { goBarba } from './barba_setup';

$.expr[':'].external = function(obj){
    return !obj.href.match(/^mailto\:/)
           && (obj.hostname != location.hostname)
           && !obj.href.match(/^javascript\:/)
           && !obj.href.match(/^$/)
};

const mainContentForTouch = false
const $html = $('html')
const $body = $('body')
const $window = $(window)
const $document = $(document)

const stickyOffset = function(){
	return 200 // html {scroll-padding-top} $('[data-main-nav]').height()
}
/*
let lazyLoadInstance = null
const lazyLoadInstanceInit = function() {
  // https://github.com/verlok/lazyload#-api
  lazyLoadInstance = new LazyLoad({
      callback_loaded: (el)=>{
        // masonry.update()
        appUtils.$window.trigger('image_loaded')
      },
      elements_selector: '.lazy',
      load_delay: 300 //adjust according to use case
  });
}
*/

let $activeModal = null
let $activeTargetSelector = null
const activeModalReset = function(event) {
  if ($activeModal) {
    const $activeModalBody = $activeModal.find('.modal-body')
    $activeModalBody.children().appendTo($activeTargetSelector)
    // $activeModalBody.html('<div class="text-center">...</div>')
    $activeModal[0].removeEventListener('hidden.bs.modal', activeModalReset)
    $activeModal[0].removeEventListener('shown.bs.modal', activeModalContentInit)
    $activeModal = null
  }
}
const activeModalContentInit = function() {
  if ($activeModal) {
    const $activeModalBody = $activeModal.find('.modal-body')
    $activeModalBody.find('.slick-initialized').slick('slickSetOption', 'autoplay', false, true)
    // $activeModalBody.find('.slick-initialized').slick('setPosition')
    $activeModalBody.removeClass('o-zero')

    $(window).trigger('resize') // start getWid counters
  }
}
const activeModalOpen = function(index, options) {
  $activeTargetSelector = options.targetSelector
  $activeModal = $(options.modalSelector)
  $activeModal[0].addEventListener('hidden.bs.modal', activeModalReset)
  $activeModal[0].addEventListener('shown.bs.modal', activeModalContentInit)
  const $activeModalBody = $activeModal.find('.modal-body')
  const $modalContent = $(options.targetSelector).children()
  $activeModalBody.html('')
  $activeModalBody.addClass('o-zero')
  $modalContent.appendTo($activeModalBody)
  
  const onModalShown = function (e) {
    // goto on shown.bs.modal to support slick adaptive height
    // https://kenwheeler.github.io/slick/
    $activeModalBody.find('.slick-initialized').slick('slickGoTo', index, true)
    $activeModal.off('shown.bs.modal', onModalShown)
  }
  $activeModal.on('shown.bs.modal', onModalShown)
  $activeModal.modal('show')
}


const appUtils = {
  // https://stackoverflow.com/questions/21664940/force-browser-to-trigger-reflow-while-changing-css
  reflow( element ) {
    if ( element === undefined ) {
      element = document.documentElement;
    }
    void( element.offsetHeight )
  },
  openModal: activeModalOpen,
  navigationToggleClass: 'has-modal-open', // 'nav-mobile--open',
  // lazyLoadInstanceInit: lazyLoadInstanceInit,
  mainContentForTouch: mainContentForTouch,
  $html: $html,
  $body: $body,
  $window: $window,
  $document: $document,
  isTouch: function () {
    if(typeof(Modernizr) === 'object'){
      return (Modernizr.touchevents)
    }else{
      // return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
      return (
        !!(typeof window !== 'undefined' &&
          ('ontouchstart' in window ||
            (window.DocumentTouch &&
              typeof document !== 'undefined' &&
              document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
          (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
      )
    }
  },
  isIos: function () {
    // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  },
  isPortrait: function () {
    // when keaborad is open, poprtrait smartphone became landscape! prevent this!
    return (window.innerWidth < window.innerHeight) || (window.innerWidth < 992)
  },

  // Bootstrap 4 breakpoints
  isXs: function () {
    return window.innerWidth < 576
  },
  isSm: function () {
    return window.innerWidth >= 576
  },
  isMd: function () {
    return window.innerWidth >= 782 // 768
  },
  isLg: function () {
    return window.innerWidth >= 992
  },
  isXl: function () {
    return window.innerWidth >= 1200
  },
  /*
  lazyUpdate: function(){
    if (lazyLoadInstance) {
        lazyLoadInstance.update()
    }
  },
  */
  scrollTo: function(selector, offset, duration ){
    if (typeof(duration) === 'undefined') {
      duration = 400
    }

    $('.is-scroll-target').removeClass('is-scroll-target')

    let scrollDestination = 0
    let dataScrollOffset = null
    if (typeof(selector) === 'string') {
      const $destination = $(selector)
      if ($destination.length) {
        $destination.addClass('is-scroll-target')
        scrollDestination = $destination.offset().top
        dataScrollOffset = ($destination.attr('data-scroll-offset')) ? parseInt($destination.attr('data-scroll-offset'), 10) : null
      }
    } else if (typeof(selector) === 'number') {
      scrollDestination = selector
    } else if (typeof(selector) === 'object') {
      if (selector.length) {
        selector.addClass('is-scroll-target')
        scrollDestination = selector.offset().top
      }
    }

    if(typeof(offset) !== 'number'){
      offset = (dataScrollOffset !== null) ? dataScrollOffset : stickyOffset()
    }

    if(scrollDestination && mainContentForTouch && appUtils.isTouch()) {
      /*
      $('#main-content').animate({
        scrollTop: scrollDestination - offset
      }, duration);
      */
      window.scrollTo({
        top: scrollDestination - offset,
        left: 0,
        behavior: "smooth",
      });
    } else {
      /*
      $('html, body').animate({
        scrollTop: scrollDestination - offset
      }, duration);
      */
      window.scrollTo({
        top: scrollDestination - offset,
        left: 0,
        behavior: "smooth",
      });
    }
  },

  // https://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
  checkDomain: function(url) {
    if ( url.indexOf('//') === 0 ) { url = location.protocol + url; }
    return url.toLowerCase().replace(/([a-z])?:\/\//,'$1').split('/')[0];
  },
  isExternal: function(url) {
    return ( ( url.indexOf(':') > -1 || url.indexOf('//') > -1 ) && appUtils.checkDomain(location.href) !== appUtils.checkDomain(url) );
  },
  goTo: function(url) {
    if (appUtils.isExternal(url)) {
      if ( (url.indexOf('|modal')!== -1) && typeof(appUtils.openIframeModal) === 'function') {
        appUtils.openIframeModal(url.replace('|modal', ''))
      } else {
        window.open(url)
      }
    } else {
      // goBarba(url)
    }
  },
  // Iframe modal
  openIframeModal: function(iframeSrc) {
    const modalMarkup = '<div class="modal fade" id="modalIframe" tabindex="-1" role="dialog" aria-labelledby="modalIframeTitle" aria-hidden="true">' +
      '<div class="modal-dialog modal-dialog-centered modal-dialog-iframe" role="document">' +
        '<div class="modal-content">' +
          '<button type="button" class="modal-close btn btn--small" data-dismiss="modal" aria-label="Close">' +
            '<span aria-hidden="true" class="icon-close"></span>' +
          '</button>' +
          '<div class="embed-responsive embed-responsive-16by9">' +
              '<iframe class="embed-responsive-item" src="' + iframeSrc + '" allow="autoplay; encrypted-media" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>'
    $('body').append(modalMarkup)

    setTimeout(()=>{
      $('#modalIframe').on('hidden.bs.modal', function (e) {
        $('#modalIframe').remove()
      }).modal('show')
    }, 0)
  },

  /*
  * App utility to append script to document body
  */
  addedScripts: [],
  addScript: function( src, callback ) {
    if (appUtils.addedScripts.indexOf(src) === -1) {
      appUtils.addedScripts.push(src)
      var s = document.createElement( 'script' )
      s.setAttribute( 'src', src )
      s.onload=callback
      //document.querySelector('#barba-wrapper .barba-container').appendChild( s )
      document.body.appendChild( s )
    } else {
      callback()
    }
  },
  reloadScript: function( src, callback ) {
    var s = document.createElement( 'script' )
    s.setAttribute( 'src', src )
    if (typeof(callback)==='function') {
      s.onload=callback
    }
    document.body.appendChild( s )
  },

  progressBarrSelector: '#progress-bar',

  triggerEvent: function(eventName, args) {
    appUtils.$window.trigger(eventName, args)
  },

  barbaHistoryUpdate: function(event, url) {
    // https://barba.js.org/docs/advanced/utils/
    // https://barba.js.org/api/classes/_core_src_utils_history_.history.html
    // barba.history.add(url, 'barba')
  }
}

export default appUtils
